(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-wall-view]').forEach(view => {
      if (view.dataset.initialized) return;
      view.dataset.initialized = 'true';
      const panel = view.closest('[data-product-panel]'), stage = view.closest('.purchase-stage');
      const photo = stage.querySelector('[data-wall-photo]'), wall = stage.querySelector('[data-wall-open]');
      const select = panel.querySelector('[data-variant]'), variants = JSON.parse(panel.querySelector('[data-variants]').textContent);
      let controller, pending, lastId;
      const selected = () => variants.find(v => String(v.id) === select.value) || variants[0];
      function sync() { const v = selected(); if (controller && v.id !== lastId) { lastId = v.id; controller.setVariant(v); } }
      function photos() {
        view.hidden = true; stage.classList.remove('is-wall'); photo.setAttribute('aria-pressed', 'true'); wall.setAttribute('aria-pressed', 'false'); controller?.setVisible(false);
      }
      photo.addEventListener('click', photos);
      stage.querySelectorAll('[data-gallery-src],[data-zoom]').forEach(b => b.addEventListener('click', photos));
      wall.addEventListener('click', async () => {
        view.hidden = false; stage.classList.add('is-wall'); photo.setAttribute('aria-pressed', 'false'); wall.setAttribute('aria-pressed', 'true');
        try {
          if (!pending) pending = import(view.dataset.runtimeUrl).then(module => module.createWallViewer(view));
          controller = await pending; sync(); controller.setVisible(!view.hidden);
        } catch (error) {
          pending = null; photos(); panel.querySelector('[data-wall-status]').textContent = '3D is unavailable. Product photos are still available.';
          wall.textContent = 'Retry wall view'; console.warn('Fellruh wall viewer:', error.message);
        }
      });
      select.addEventListener('change', sync);
      const observer = new MutationObserver(sync); observer.observe(panel.querySelector('[data-variant-note]'), { childList: true, subtree: true });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(view)) { observer.disconnect(); controller?.dispose(); } });
      window.addEventListener('pagehide', event => { if (!event.persisted) { observer.disconnect(); controller?.dispose(); } });
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
